import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InformationComponent} from "./information.component";
import {AttributionComponent} from "./attribution/attribution.component";


const routes: Routes = [{

  path: '',
  component: InformationComponent,
  children: [
    {
      path: 'attribution',
      component: AttributionComponent
    }
  ]

}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InformationRoutingModule { }
